const mapStateToProps = (state) => {
    const {
        api:{
            geoObjs,
        }={},
        ui:{
            selectedGeoObjArray,
        }={},
        geozone:{
            geozoneArr,
            geozoneSettingsArr,
        }={},
        route:{
            routeArr,
            routeSettingsArr,
        }={},
    }=state;
    return {
        geoObjs,
        routeArr,
        routeSettingsArr,
        selectedGeoObjArray,
        geozoneArr,
        geozoneSettingsArr,
    }
}

export default mapStateToProps;